import * as React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { Notifications, Orders } from '../../store/slices';
import { setHoldStatus } from '../../api';
import { AppDialog } from '../ui';
import { errorMessage } from '../../lib/errorMessage';

/** Hold / unhold confirmation. */
interface OrderHoldStateProps {
    holdStatus: boolean | number | undefined;
    isPopUp: boolean;
    popUpHandler: (closed?: boolean) => void;
}

export default function OrderHoldState({ holdStatus, isPopUp, popUpHandler }: OrderHoldStateProps) {
    const { id, companyId } = useParams();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);

    const getOrder = () => {
        dispatch<any>(Orders.getOrder({ id: id || '', companyId: companyId || '' }));
    };

    const submit = async () => {
        if (pending) return;
        setPending(true);
        try {
            await setHoldStatus({
                id,
                companyId,
                holdStatus,
                onSuccess: () => {
                    dispatch(Notifications.setNotifications({ text: 'Hold status updated', type: 'success' }));
                    popUpHandler(true);
                    getOrder();
                },
            });
        } catch (error) {
            dispatch(Notifications.setNotifications({ text: errorMessage(error), type: 'error' }));
        } finally {
            setPending(false);
        }
    };

    return (
        <AppDialog
            open={Boolean(isPopUp)}
            onClose={() => popUpHandler(true)}
            title={holdStatus ? 'Release the hold?' : 'Put the order on hold?'}
            description={holdStatus
                ? `Order ${id} goes back into the normal flow.`
                : `Order ${id} stays out of production and shipping until the hold is released.`}
            pending={pending}
            maxWidth="xs"
            actions={(
                <>
                    <Button variant="outlined" onClick={() => popUpHandler(true)}>Keep as is</Button>
                    <Button variant="contained" onClick={submit} disabled={pending}>{holdStatus ? 'Unhold order' : 'Hold order'}</Button>
                </>
            )}
        />
    );
}
